import {TicketDetailVo} from '../../common/shared/api/nicolas/vo/TicketDetailVo.interface';
import {getTicketTitle} from '../../design-system/organisms/HistoryItem/getTicketTitle.function';
import {TicketDetail} from '../generated/types';
import {createRefundableTicketInfo} from './RefundableTicketInfo';
import {createSalesTicketItem} from './SalesTicketItem';

export function createTicketDetail({
  is_vod,
  refundable_cash,
  refund_ticket_info,
  refundable_ticket_num,
  sales_ticket,
  date_compare,
  vod_discount_price,
  ticket_uid,
  series,
}: TicketDetailVo): TicketDetail {
  return {
    isVod: is_vod,
    refundableCash: refundable_cash,
    refundTicketInfo: refund_ticket_info
      ? createRefundableTicketInfo(refund_ticket_info)
      : refund_ticket_info,
    refundableTicketNum: refundable_ticket_num,
    salesTicket: sales_ticket
      ? createSalesTicketItem(sales_ticket)
      : sales_ticket,
    dateCompare: date_compare,
    vodDiscountPrice: vod_discount_price,
    ticketUid: ticket_uid,
    productType: sales_ticket
      ? getTicketTitle(sales_ticket?.ticket_type)
      : undefined,
  };
}
